// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__PASJk","item":"styles_item__UJZLl"};